import { httpsCallable } from 'firebase/functions';
import { getFns } from '../firebase/functions';

/**
 * Wrappers des callables de contrôle d'accès admin (allowlist d'e-mails,
 * pilotable depuis l'admin). La vérité est serveur (`functions/admin-access`).
 */

export type MyAccess = { admin: boolean; email: string | null };

/** L'utilisateur connecté est-il admin ? (gating UI) */
export async function fetchMyAccess(): Promise<MyAccess> {
  const fns = getFns();
  if (!fns) return { admin: false, email: null };
  const callable = httpsCallable<Record<string, never>, MyAccess>(fns, 'getMyAccess');
  const res = await callable({});
  return { admin: res.data?.admin === true, email: res.data?.email ?? null };
}

/** Liste des e-mails admin (réservé admin). */
export async function fetchAdminEmails(): Promise<string[]> {
  const fns = getFns();
  if (!fns) throw new Error('Firebase non configuré.');
  const callable = httpsCallable<Record<string, never>, { adminEmails: string[] }>(fns, 'getAdminAccess');
  const res = await callable({});
  return Array.isArray(res.data?.adminEmails) ? res.data.adminEmails : [];
}

/** Met à jour l'allowlist admin (réservé admin ; impossible de se retirer). */
export async function saveAdminEmails(emails: string[]): Promise<string[]> {
  const fns = getFns();
  if (!fns) throw new Error('Firebase non configuré.');
  const callable = httpsCallable<{ adminEmails: string[] }, { adminEmails: string[] }>(fns, 'setAdminAccess');
  // Tableau plain (jamais un proxy $state).
  const plain = JSON.parse(JSON.stringify(emails)) as string[];
  const res = await callable({ adminEmails: plain });
  return Array.isArray(res.data?.adminEmails) ? res.data.adminEmails : [];
}
